import { render, staticRenderFns } from "./Wisdommarket.vue?vue&type=template&id=0937c418&scoped=true"
import script from "./Wisdommarket.vue?vue&type=script&lang=js"
export * from "./Wisdommarket.vue?vue&type=script&lang=js"
import style0 from "./Wisdommarket.vue?vue&type=style&index=0&id=0937c418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937c418",
  null
  
)

export default component.exports